import { a163, a748, a750 } from "Components/Api/RootApiPath";

export const fetchAllRates = async ({ queryKey }) => {
  const [, clientCode] = queryKey;
  try {
    const data = await fetch(a750, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ClientCode: clientCode,
      }),
    });
    if (!data.ok) {
      throw new Error(
        `${response.statusText || "Failed to fetch sku list"}`
      );
    }
    const res = await data?.json();
    return res;
  } catch (e) {
    console.log(e.message);
    throw new Error(`${"Failed to fetch sku list, try again later"}`);
  }
};